import React from "react";
import {css} from "@panda/css";

import {IOfferBoxOffer} from "../../types/IOfferBoxOffer";
import {getOfferUsps} from "../../utils/get_offer_usps";
import {OfferBoxUspChip} from "./OfferBoxUspChip";

interface IProps {
    offer: IOfferBoxOffer;
}

export const OfferBoxUspSection = (props: IProps) => {
    const usps = getOfferUsps(props.offer);

    return (
        <div className={uspSectionStyle}>
            {usps.map((usp) => (
                <OfferBoxUspChip key={usp.id} usp={usp} />
            ))}
        </div>
    );
};

const uspSectionStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    minHeight: "2.4rem"
});
import React from "react";
import {css} from "@panda/css";

import {IOfferBoxOffer} from "../../types/IOfferBoxOffer";
import {getOfferUsps} from "../../utils/get_offer_usps";
import {OfferBoxUspChip} from "./OfferBoxUspChip";

interface IProps {
    offer: IOfferBoxOffer;
}

export const OfferBoxUspSection = (props: IProps) => {
    const usps = getOfferUsps(props.offer);

    return (
        <div className={uspSectionStyle}>
            {usps.map((usp) => (
                <OfferBoxUspChip key={usp.id} usp={usp} />
            ))}
        </div>
    );
};

const uspSectionStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    minHeight: "2.4rem"
});
